<template>
  <div class="event-navigation border-gray-500 -mx-10">
    <nav class="sm:mx-8">
      <ul class="flex flex-col font-semibold text-gray-700 text-lg sm:flex-row">
        <router-link
          tag="li"
          class="nav-item"
          :to="{ name: 'event.track.search', params: { id: routeId }}"
          exact-active-class="active"
        >
          Suche
        </router-link>
        <router-link
          tag="li"
          class="nav-item"
          :to="{ name: 'event.playlist', params: { id: routeId }}"
          exact-active-class="active"
        >
          Playlist
        </router-link>
        <router-link
          v-if="isDefaultUser"
          tag="li"
          class="nav-item"
          :to="{ name: 'event.guests.access', params: { id: routeId }}"
          exact-active-class="active"
        >
          Gästezugang
        </router-link>
      </ul>
    </nav>
    <hr
      class="w-full block bg-gray-200 m-0"
      style="height: 2px; margin-top: -2px;"
    >
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EventNavigation',

  data() {
    return {
      routeId: null,
    };
  },

  computed: {
    ...mapGetters(['isDefaultUser']),
  },

  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.params.id) {
          this.routeId = route.params.id;
        }
      },
    },
  },

};

</script>

<style lang="scss" scoped>

.nav-item {
  @apply py-4;
  @apply px-5;
  @apply cursor-pointer;
  @apply border-b-2;
  @apply border-gray-200;
  &:hover {
    @apply text-pink-700;
    @apply bg-pink-100;
  }

  &.active {
    @apply text-pink-500;
    @apply border-b-2;
    @apply border-pink-500;
  }

  @media(min-width: theme('screens.sm')) {
    @apply pt-4;
    @apply pb-4;
    @apply border-b-0;
    &:hover {
      @apply text-pink-300;
      @apply bg-transparent;
  }
  }
}

</style>
